import { Component, Input } from '@angular/core';
import { GlobalDataService } from '../services/global-data.service';

@Component({
  selector: 'app-descreportmain',
  templateUrl: './descreportmain.component.html',
  styleUrls: ['./descreportmain.component.css']
})

export class DescreportmainComponent {
  showLoginPanel = false;
  @Input() bannertitle: string;
  @Input() bannerversion: string;
  @Input() bannerdatabase: string;
  @Input() banneruser: string;
  @Input() password: string;

  constructor( public globals: GlobalDataService) { }

  activateLogin() {
    this.globals.showLoginPanel = true;
  }

  logout() {
    this.banneruser = 'guest';
    this.password = '';
    this.globals.username = 'guest';
    this.globals.encryptedPassword = '';
    this.globals.showLoginPanel = false;
  }
}

export class LoginComponent {
  @Input() banneruser: string;
  @Input() password: string;
  constructor() { }

}
